import { Spinner } from 'react-bootstrap';
import cn from 'classnames';

import { type ICountBadge } from '@/types/ICountBadge';

import styles from './countBadge.module.scss';

export const CountBadge: React.FC<ICountBadge> = ({
  count,
  isLoading = false,
  className
}) => (
  <span className={cn(styles['count-badge'], className)}>
    {isLoading ? (
      <Spinner
        animation="border"
        role="status"
        aria-label="Загружаем счётчик"
        className={styles['count-badge__spinner']}
      />
    ) : (
      count
    )}
  </span>
);
